import { companyDataResponse } from "./companyDataResponse";
const msPerDay: number = 86400000;

export function handleReturnedResponse(response: companyDataResponse): string | number {
  if (response.returnValueIsNumeric || false) return Number.parseFloat(response.formattedReturn);

  if (response?.result?.unit?.simplifiedReturnType == "datetime") {
    const date = new Date(response.formattedReturn);
    const excelEpoch = Date.UTC(1899, 11, 30);
    const timezoneOffsetMs = date.getTimezoneOffset() * 60000;
    const timeDiff = date.getTime() - excelEpoch;
    const excelDateUTC = timeDiff / msPerDay;
    const excelDateLocal = excelDateUTC - timezoneOffsetMs / msPerDay;

    return excelDateLocal;

    // const date = new Date(response.formattedReturn);
    // const excelEpoch = Date.UTC(1899, 11, 30);
    // const msPerDay = 86400000;

    // const timeDiff = date.getTime() - excelEpoch;

    // return timeDiff / msPerDay;
  }

  if (response?.result?.unit?.simplifiedReturnType == "date") {
    return new Date(response.formattedReturn).toISOString();
  }

  return response?.formattedReturn || "";
}
